// Toast UI editor wrapper for the Admin Hub. Same WYSIWYG-over-Markdown editor
// the Workspace already uses (no second rich-text dependency), with an image
// hook that uploads dropped/pasted images to PocketBase and inserts the Markdown
// for you. Lazy-loaded so it never weighs down the public bundle.
import { uploadMedia } from "../cms/api.js";

// Mount an editor into `el`. Returns the editor instance (or null on failure).
// `onImageError` is called with a friendly message if an upload fails.
export async function mountEditor(el, initialMarkdown, onImageError) {
  if (!el) return null;
  try {
    const [{ default: Editor }] = await Promise.all([
      import("@toast-ui/editor"),
      import("@toast-ui/editor/dist/toastui-editor.css"),
    ]);
    if (!document.body.contains(el)) return null; // navigated away while loading
    el.innerHTML = "";
    return new Editor({
      el,
      height: "480px",
      initialEditType: "wysiwyg",
      previewStyle: "tab",
      initialValue: initialMarkdown || "",
      usageStatistics: false,
      autofocus: false,
      hooks: {
        addImageBlobHook: async (blob, callback) => {
          try {
            const url = await uploadMedia(blob, blob.name || "");
            callback(url, blob.name || "image");
          } catch (err) {
            if (onImageError) onImageError("Image upload failed — please try again.");
          }
        },
      },
    });
  } catch {
    el.innerHTML = `<p class="text-rose-600 text-sm py-6 text-center">Couldn't load the editor — refresh and try again.</p>`;
    return null;
  }
}
